import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import imgSortDown from '../../images/common/ic_down.svg';
import imgSortUp from '../../images/common/ic_up.svg';
import imgNoSort from '../../images/common/ic_top_down.svg';

const DefaultMark = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 3px;
  width: 15px;
  height: 24px;
`;

const DefaultMarkData = styled.div`
  font-size: 10px;
  margin: 0px;
  padding: 0px;
  width: 15px;
  height: 20px;
  color: rgba(255, 255, 255, 0.2);
`;

const style = {
  defaultSortMarkIcon: {
    width: '100%',
    height: '100%',
    fontSize: 20,
  },
  sortMark: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 3,
    width: 15,
    height: 20,
    fontSize: 20,
  },
};

const defaultSortMark = () => (
  <DefaultMark>
    <DefaultMarkData>
      <img style={style.defaultSortMarkIcon} src={imgNoSort} alt="" />
    </DefaultMarkData>
  </DefaultMark>
);

/**
 * ソート順序を示すマーク（矢印アイコン）を表示するコンポーネント
 * @param {Object} props
 * @param {boolean} props.sort ソートが有効かどうかを示すブール値。trueの場合、ソートマークが表示される
 * @param {string} props.order ソートの順序を示す文字列。'D'の場合は降順、それ以外の場合は昇順
 */
const SortMark = ({ sort, order }) => {
  const sortMark = order === 'D' ? imgSortDown : imgSortUp;
  return (
    <Fragment key={`sortMark${order}`}>
      {(sort && <img style={style.sortMark} src={sortMark} alt="" />) ||
        defaultSortMark()}
    </Fragment>
  );
};

SortMark.propTypes = {
  sort: PropTypes.bool.isRequired,
  order: PropTypes.string.isRequired,
};

export default SortMark;
